'use strict';

import axios from 'axios';
import * as dom from '../lib/dom.js';

let podcastAudio;
let audioState = 'stop';
let audioBarFeedback;
let scPlayerLoading = false;
let playPauseBtn = false;
let playerAudio;
let playerBar;
let players = [];


const onYouTubeIframeReady = () => {
    console.log('onYouTubeIframeReady');
    let countPlayers = 0;
    

    const iframes = document.querySelectorAll('.c-podcast-card-iframe');
    console.log(iframes);
    if (iframes.length > 0) {
        dom.forEachEl(iframes, (iframe) => {
            let player;
            const videoID = iframe.getAttribute('data-video-id');
            const iframeID = iframe.getAttribute('id');
            console.log(videoID);
            console.log(iframeID);
                
                
            player = new YT.Player(iframeID, {
                videoId: videoID,
                events: {
                    // 'onReady': onPlayerReady,
                    'onStateChange': onPlayerStateChange
                }
            });

            players.push(player);

            
        });

        function onPlayerStateChange(event) {
            if (event.data == YT.PlayerState.PLAYING) {
                var temp = event.target.playerInfo.videoUrl;
                for (var i = 0; i < players.length; i++) {
                    if (players[i].playerInfo.videoUrl != temp) 
                        players[i].pauseVideo();
                }
            }
        }
    }
}

const loadIframeApi = () => {
    console.log('loadIframeApi');
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    // tag.setAttribute("onload", "window.onYouTubeIframeReady()");
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    tag.addEventListener("load", function(event) {
        console.log("script loaded :)");
        setTimeout(() => {
            onYouTubeIframeReady();
        }, 700);
    });
}




const secondsToHms = (d) => {
    d = Number(d);
    const h = Math.floor(d / 3600);
    const m = Math.floor(d % 3600 / 60);
    const s = Math.floor(d % 3600 % 60);

    const hDisplay = h > 0 ? (h < 10 ? '0' : '') + h + ':' : '00:';
    const mDisplay = m > 0 ? (m < 10 ? '0' : '') + m + ':' : '00:';
    const sDisplay = s > 0 ? (s < 10 ? '0' : '') + s : '';
    return hDisplay + mDisplay + sDisplay;
}

function resetProgressValue() {
    const spanCurrentTime = document.querySelector('.c-podcast-bar__current-time');
    const spanTotalTime = document.querySelector('.c-podcast-bar__total-time');
    console.log('resetProgressValue');
    spanCurrentTime.innerHTML = '-:--:--';
    spanTotalTime.innerHTML = '--:--:--';
}

function goToTimeByProgressBar(e) {
    let touchend = e.type === 'touchend' || e.type === 'touchcancel',
            pageX = touchend ? e.changedTouches[0].pageX : e.offsetX;

    if (touchend) {
        const audioBarFeedbackToolTip = document.querySelector('.js-podcast-bar-feedback-tooltip');
         audioBarFeedbackToolTip.style.opacity = 0;
    }

    let percent = pageX / e.target.offsetWidth || (e.layerX - e.target.offsetLeft) / e.target.offsetWidth;

    percent = percent * (podcastAudio.duration || 0);
    console.log(e);
    console.log(percent);
    podcastAudio.currentTime = percent;
}

function showProgressValue(e) {
    let touchstart = e.type === 'touchstart' || e.type === 'touchmove',
            pageX = touchstart ? e.targetTouches[0].pageX : e.pageX,
            x = touchstart ? e.targetTouches[0].clientX : e.clientX



    let percent = pageX / e.target.offsetWidth || (e.layerX - e.target.offsetLeft) / e.target.offsetWidth;
    percent = percent * (podcastAudio.duration || 0);

    let tooltopPosition = x - 37 + 'px';
    const audioBarFeedbackToolTip = document.querySelector('.js-podcast-bar-feedback-tooltip');

    if (x >= window.innerWidth - 100) {
        tooltopPosition = x - 37 + 'px';
    }

    // console.log(percent);
    // console.log(tooltopPosition);

    if (touchstart) {
        audioBarFeedbackToolTip.style.opacity = 1;
    }

    audioBarFeedbackToolTip.style.left = tooltopPosition;
    audioBarFeedbackToolTip.innerHTML = secondsToHms(percent);
}

const updateProgressBar = () =>{
    console.log('updateProgressBar');
    if (!podcastAudio) { return }
    podcastAudio.addEventListener('timeupdate', function () {
        const newValue = Math.round((Math.floor(podcastAudio.currentTime) * 100) / podcastAudio.duration);
        const spanCurrentTime = document.querySelector('.c-podcast-bar__current-time');
        const spanTotalTime = document.querySelector('.c-podcast-bar__total-time');

        spanCurrentTime.innerHTML = secondsToHms(podcastAudio.currentTime);
        spanTotalTime.innerHTML = secondsToHms(podcastAudio.duration);
        audioBarFeedback.value = newValue;
    });
}



const togglePlayPauseAudio = () =>{
    playPauseBtn.addEventListener('click', (e) => {
        e.preventDefault();
        console.log('playPauseBtn');
        console.log(podcastAudio.paused);

        const playPauseBtnIconAnimationFPauseTPlay = playPauseBtn.querySelector('#from_pause_to_play');
        const playPauseBtnIconAnimationFPlayTPause = playPauseBtn.querySelector('#from_play_to_pause');

        podcastAudio.addEventListener('waiting', function () {
            scPlayerLoading = true;
            dom.addClass(playPauseBtn, 'c-play-podcast-trigger--loading');
        });

        podcastAudio.addEventListener('canplaythrough', function () {
            scPlayerLoading = false;
            dom.removeClass(playPauseBtn, 'c-play-podcast-trigger--loading');
        });

        if (podcastAudio.paused) {
            podcastAudio.play();
            audioState = 'play';
            dom.addClass(playPauseBtn, 'c-play-podcast-trigger--playing');
            dom.removeClass(playPauseBtn, 'c-play-podcast-trigger--paused');
            playPauseBtnIconAnimationFPauseTPlay.beginElement();



        } else {
            podcastAudio.pause();
            audioState = 'pause';
            dom.addClass(playPauseBtn, 'c-play-podcast-trigger--paused');
            dom.removeClass(playPauseBtn, 'c-play-podcast-trigger--playing');

            playPauseBtnIconAnimationFPlayTPause.beginElement();
        }
    })
}

const getAudioPodcast = () =>{
    console.log('get audio');

    playPauseBtn = document.querySelector('.js-play-podcast');
    audioBarFeedback = document.querySelector('.js-podcast-bar-feedback-current');
    podcastAudio = document.querySelector('.js-audio-el');
    const volumeBar = document.querySelector('.js-play-podcast-voulme-bar');
    const more10 = document.querySelector('.js-play-podcast-time-more');
    const less10 = document.querySelector('.js-play-podcast-time-less');
    const closeBar = document.querySelector('.js-close-podcast-bar');

    updateProgressBar();

    podcastAudio.volume = volumeBar.value;
    togglePlayPauseAudio();

    audioBarFeedback.addEventListener('mousemove', function(e){
        showProgressValue(e);
    });

    audioBarFeedback.addEventListener('touchmove', function(e){
        // console.log(e);
        showProgressValue(e);
    });

    audioBarFeedback.addEventListener('touchend', function(e){
        console.log('audioBarFeedback');
        console.log(e);
        goToTimeByProgressBar(e);
    });

    audioBarFeedback.addEventListener('touchcancel', function(e){
        console.log('audioBarFeedback');
        goToTimeByProgressBar(e);
    });

    audioBarFeedback.addEventListener('click', function(e){
        console.log('audioBarFeedback');
        goToTimeByProgressBar(e);
    });

    volumeBar.addEventListener('change', function(e){
        podcastAudio.volume = volumeBar.value;
    });

    more10.addEventListener('click', function(e){
        e.preventDefault();
        podcastAudio.currentTime = podcastAudio.currentTime + 10;
    });

    less10.addEventListener('click', function(e){
        e.preventDefault();
        podcastAudio.currentTime = podcastAudio.currentTime - 10;
    });

    closeBar.addEventListener('click', (e) => {
        console.log('close bar');
        e.preventDefault();

        dom.removeClass(playerBar, 'c-podcasts--show');
        dom.addClass(playerBar, 'c-podcasts--closed');
        podcastAudio.pause();
        podcastAudio.removeAttribute('src');

        setTimeout(function () {
            document.querySelector('.c-podcasts-holder audio').remove();
            podcastAudio = false;
        }, 350);
    });

}

const showPodcastBar = () =>{
    playerBar = document.querySelector('.js-player-enable');
    playerAudio = document.querySelector('.js-audio-el');

    setTimeout(function () {
        if (!dom.hasClass(playerBar, 'c-podcasts--show') && !dom.hasClass(playerBar, 'c-podcasts--closed') ){
            dom.addClass(playerBar, 'c-podcasts--show');
        }

    }, 250);
}

const loadContentFromSingle = (url = false) => {
    let playDirect = false;
    if (!url) {
        url = window.location.href + '?is_ajax=true&player';
    } else {
        url =  url + '?is_ajax=true&player';
        playDirect = true;
    }

    if(podcastAudio) {
        podcastAudio.pause();
    }

    dom.removeClass(playerBar, 'c-podcasts--show');

    axios
    .get(url)
    .then(function (response) {
        const podcastPlayerHolder = document.querySelector('.js-podcasts-holder');

        setTimeout(function () {

            podcastPlayerHolder.innerHTML = response.data;
            getAudioPodcast();
            dom.removeClass(playerBar, 'c-podcasts--closed');
            console.log('loadContentFromSingle');
            showPodcastBar();

            if (playDirect) {
                emulatePlayPauseClick(playPauseBtn);
            }
        }, 260);
    })
    .catch(function (error) {
        console.log('error', error);
    });

}

const emulatePlayPauseClick = () => {
    const evObj = document.createEvent('Events');
    evObj.initEvent('click', true, false);
    playPauseBtn.dispatchEvent(evObj);
}

export default function(){
    window.addEventListener("turbolinks:load", function() {
        showPodcastBar();
        // const audioControlRef = document.querySelector('.js-play-podcast');
        // const bodyEl = document.querySelector('body');

        // if (dom.hasClass(bodyEl, 'single-podcasts')) {
        //     const podcastTitleLink = document.querySelector('.c-podcasts__item-link');
        //         const podcastTitleLinkFromBanner = document.querySelector('.c-slider__banner-slider-content .js-play-btn-svg').getAttribute('data-url');
        //     if (!dom.hasClass(audioControlRef, 'c-play-podcast-trigger--playing') && podcastTitleLink != podcastTitleLinkFromBanner) {
        //         console.log('loadContentFromSingle');

        //         loadContentFromSingle();
        //     } else {
        //         showPodcastBar();
        //     }
        // } else {

        // }

        const playBtnEl = document.querySelectorAll('.js-play-btn-svg');

        if (playBtnEl) {
            playBtnEl.forEach((el)=>{
                if (!dom.hasClass(el, 'has-event-listener')) {
                    dom.addClass(el, 'has-event-listener');
                    el.addEventListener('click', (e) => {
                        const podcastTitleLink = document.querySelector('.c-podcasts__item-link');
                        e.preventDefault();
                        console.log(podcastTitleLink.href);
                        console.log(el.getAttribute('data-url'));

                        if (podcastTitleLink.href !== el.getAttribute('data-url') || !podcastAudio) {
                            loadContentFromSingle(el.getAttribute('data-url'));
                        } else {
                            emulatePlayPauseClick();
                        }
                    });
                }
            });
        }

        if (typeof YT === 'undefined') {
            console.log('teste1');
            loadIframeApi();
        } else {
            onYouTubeIframeReady();
        }
        
    });

    window.addEventListener("load", function() {
        getAudioPodcast();
        if (typeof YT === 'undefined') {
            console.log('teste2');
            loadIframeApi();
        }
    });
}
